<template>
<transition name="slide-fade">
    <div class="dialog-view" v-show="visible">        
        <div class="old-modal u-window">           
            <div class="dialog-content">              
                <div class="u-btn close" @click="destroyElement"></div>
                <div class="dialog-wrapper">
                    <div class="dialog-title t-old"></div>
                    <p v-for="(item,index) in rule_text" :key="index"><em class="index">{{ index + 1 }}</em>{{ item }}</p>
                    <div class="u-btn ok" @click="destroyElement"></div>
                </div>
            </div>
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>    
</template>

<script>
export default {
    name : 'old_modal',
    data : function () {
        return {
            visible : false,
            rule_text : ['被招募者游戏等级需要≥11级',
            '最后一次登录在2021年12月10日之前，且最近一个月内没有登录过',
            '历史出征/竞技局数≥50局',
            ],            
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    methods: {
        destroyElement () {
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },
    }    
}
</script>

<style scoped>

@media screen and (min-device-width: 1025px){
    .old-modal{
        width: 469px;
        height: 381px;
        background-image: url(../../images/bg-modal-old.png);
    }

    .t-old{
        width: 244px;
        height: 38px;
        margin: 0 auto 35px;
        background-image: url(../../images/title-old.png);
    }

    .old-modal .dialog-wrapper{
        padding: 45px 40px 0;
    }    

    .old-modal p{
        position: relative;
        color: #63544b;
        line-height: 1.8;
        padding-left: 40px;
        margin: 0 45px 12px;
    }

    .old-modal p .index{
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        width: 27px;
        height: 27px;
        line-height: 27px;
        background-image: url(../../images/bg-index.png);
        color: #e6dac0;
        font-weight: 700;
        text-align: center;
    }

    .u-btn.ok{
        width: 166px;
        height: 49px;
        margin: 25px auto 0;
        background-image: url(../../images/btn-iknow.png);    
    }
    
    .u-btn.ok:hover{
        background-image: url(../../images/btn-iknow_hover.png);   
    }  
}

@media screen and (max-device-width: 1024px){
    .old-modal{
        width: 609px;
        height: 411px;
        background-image: url(../../images/m/bg-modal-old.png);
    }

    .t-old{
        width: 292px;
        height: 46px;
        margin: 0 auto 15px;
        background-image: url(../../images/m/title-old.png);
    }

    .old-modal .dialog-wrapper{
        padding: 45px 40px 0;
    }    

    .old-modal p{
        position: relative;
        color: #63544b;
        line-height: 1.6;
        padding-left: 50px;
        margin: 0 45px 12px;
    }

    .old-modal p .index{
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        width: 43px;
        height: 43px;
        line-height: 43px;
        background-image: url(../../images/m/bg-index.png);
        color: #e6dac0;
        font-weight: 700;
        text-align: center;
    }

    .u-btn.ok{
        width: 218px;
        height: 65px;
        margin: 25px auto 0;
        background-image: url(../../images/m/btn-iknow.png);    
    }
    
}

      
</style>


// WEBPACK FOOTER //
// src/components/OldModal/oldModal.vue